<template>
    <div>
        <div class="relative w-full max-w-screen-xl h-full mx-auto px-6 py-12">

            <!-- If uploading -->
            <div v-if="uploading" class="absolute w-full h-full top-0 left-0 z-50">
                <div class="absolute z-20 top-0 right-0 w-full h-full bg-white opacity-90"></div>
                <div class="absolute z-30 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                    <div class="text-2xl font-bold text-center">
                        {{ __('home::orders.uploading_images') }}
                        ({{ uploadPercentage }}%)
                    </div>
                    <svg class="mt-12 h-12 w-12 animate-spin mx-auto" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
            </div>

            <div class="grid lg:grid-cols-5 lg:gap-16">
                <div class="lg:col-span-3 bg-white">

                    <div class="bg-primary-light text-primary px-4 py-3 rounded-lg mb-4 text-center" v-if="order.photos.length > 0">
                        {{ __('home::orders.photos_help_text') }}
                    </div>

                    <!-- Photos -->
                    <div class="w-full grid grid-cols-2 md:grid-cols-3 gap-0 lg:gap-0 justify-center">

                        <button
                            type="button"
                            class="block relative w-full h-auto bg-gray-50 bg-cover bg-center bg-no-repeat cursor-pointer outline-none transition duration-300 hover:scale-105"
                            :style="{
                                paddingBottom: '100%',
                            }"
                            v-for="photo in order.photos"
                            :key="photo.id"
                            @click="editing = photo"
                        >
                            <div
                                class="absolute z-20 top-0 right-0 w-full h-full bg-cover bg-center bg-no-repeat"
                                :style="{
                                    backgroundImage: 'url(' + photo.product.primary_image.public_path + ')'
                                }"
                            ></div>

                            <div
                                class="absolute z-10 bg-cover bg-center bg-no-repeat"
                                :style="{
                                    width: (100 - photo.product.padding.left - photo.product.padding.right) + '%',
                                    height: (100 - photo.product.padding.top - photo.product.padding.bottom) + '%',
                                    marginTop: photo.product.padding.top + '%',
                                    marginRight: photo.product.padding.right + '%',
                                    marginBottom: photo.product.padding.bottom + '%',
                                    marginLeft: photo.product.padding.left + '%',
                                    backgroundImage: 'url(' + photo.thumb_path + ')'
                                }"
                            ></div>

                            <div
                                class="absolute z-20 top-1/2 left-1/2 -mt-6 -ml-6 bg-red-700 rounded-md shadow-lg"
                                v-if="photo.warnings?.length > 0"
                            >
                                <ExclamationIcon class="w-12 h-12 text-white" />
                            </div>
                        </button>

                        <!-- Add new -->
                        <div>
                            <Menu as="div" class="relative">
                                <div>
                                    <MenuButton
                                        class="block relative top-0 left-0 h-auto w-full bg-cover bg-gray-50 bg-center bg-no-repeat cursor-pointer text-gray-400 hover:text-gray-600 outline-none"
                                        :style="{
                                            paddingBottom: (100 * selectedShape.ratio) + '%',
                                            marginTop: ((100 - (100 * selectedShape.ratio)) / 2) + '%',
                                            marginBottom: ((100 - (100 * selectedShape.ratio)) / 2) + '%',
                                        }"
                                        @click="$refs.files.click()"
                                    >
                                        <div
                                            class="absolute top-0 right-0 w-full h-full bg-cover bg-center bg-no-repeat"
                                            :style="{
                                                backgroundImage: 'url(' + selectedShape.primary_image?.public_path + ')'
                                            }"
                                        ></div>
                                        <div class="absolute z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
                                            <PlusIcon class="inline-block w-14 h-14" />
                                            <div class="text-sm mt-4">{{ __('home::orders.add_another_photo') }}</div>
                                        </div>
                                    </MenuButton>
                                </div>

                                <!--
                                <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                    <MenuItems class="origin-center absolute left-1/2 -ml-6 top-32 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                        <div class="py-1">
                                            <MenuItem v-slot="{ active }">
                                                <button type="button" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full text-left px-4 py-2 text-sm']" @click="$refs.files.click()">
                                                    {{ __('home::orders.upload_photo') }}
                                                </button>
                                            </MenuItem>
                                            <MenuItem v-slot="{ active }">
                                                <button type="button" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full text-left px-4 py-2 text-sm']" @click="stockPhotoSelectorOpen = true">
                                                    {{ __('home::orders.use_stock_photo') }}
                                                </button>
                                            </MenuItem>
                                            <MenuItem v-slot="{ active }">
                                                <button type="button" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block w-full text-left px-4 py-2 text-sm']" @click="socialPhotoSelectorOpen = true">
                                                    {{ __('home::orders.use_social_photo') }}
                                                </button>
                                            </MenuItem>
                                        </div>
                                    </MenuItems>
                                </transition>
                                -->
                            </Menu>

                            <input type="file" ref="files" accept="image/*" multiple class="hidden" @change="handleFileUploads()" />

                        </div>

                    </div>


                </div>

                <div class="lg:col-span-2 mt-12 lg:mt-0">

                    <div class="px-8 py-10 shadow-xl rounded-lg border border-gray-200">

                        <!-- Shape options -->
                        <div class="flex justify-between items-center">
                            <h1 class="font-semibold text-xl">
                                {{ __('home::orders.shape_select') }}
                            </h1>
                            <span class="text-sm">
                                {{ __('home::orders.shape_select_subtitle') }}
                            </span>
                        </div>

                        <div class="mt-6 mb-10">
                            <div class="grid grid-cols-3 lg:grid-cols-4 gap-4">
                                <button
                                    type="button"
                                    class="hover:scale-110 duration-100 pb-2"
                                    :class="{
                                        'border-b-2 border-primary': shape.id === selectedShape.id,
                                    }"
                                    @click="updateShape(shape)"
                                    v-for="shape in shapes"
                                >
                                    <img :src="shape.secondary_image?.public_path" class="block h-auto w-auto" />
                                    <div class="text-xxs text-gray-600 text-center pt-1">{{ shape.size_info }}</div>
                                </button>
                            </div>
                        </div>

                        <!-- Summary -->
                        <h1 class="font-semibold text-xl">
                            {{ __('home::checkout.summary') }}
                        </h1>

                        <div class="mt-6">

                            <div class="flex justify-between py-1 text-sm">
                                <div class="flex gap-2 items-center">
                                    <span>
                                        {{ order.photos.length }}
                                        {{ order.photos.length == 1 ? __('home::orders.photo_tile').toLowerCase() : __('home::orders.photo_tiles').toLowerCase() }}
                                    </span>

                                    <div
                                        class="px-2 py-0.5 text-xs rounded-full shadow-sm font-bold text-center"
                                        :class="[$page.props.__site.promotion_style === 'black_friday'
                                            ? 'text-black bg-[#ffd732]'
                                            : 'text-primary bg-primary-light']"
                                                v-if="$page.props.__site.promotion_product_line"
                                                v-html="$page.props.__site.promotion_product_line"
                                    />
                                </div>
                                <span>
                                    {{ formatPrice(subtotalPrice, order.currency) }}
                                </span>
                            </div>

                            <div class="flex justify-between py-1 text-sm">
                                <span>
                                    {{ __('home::checkout.delivery') }}
                                </span>
                                <span>
                                    {{ formatPrice(deliveryPrice, order.currency) }}
                                </span>
                            </div>

                            <div class="text-sm font-bold mt-2" v-if="order.photos.length < 4">
                                {{ __('home::orders.free_delivery_info', { count: 4 - order.photos.length }) }}
                            </div>

                            <div class="px-4 py-2 rounded-sm shadow-sm text-xs lg:text-sm text-primary bg-primary-light text-center mt-6" v-if="! delayedPaymentDays">
                                {{ __('home::orders.delivery_at_latest') }}
                                <button type="button" class="inline font-bold border-b border-dashed border-primary focus:outline-none" @click="deliveryInfoOpen = true">
                                    {{ __('home::orders.on').toLowerCase() }} {{ nextDelivery }}
                                </button>
                            </div>

                            <div class="px-4 py-2 rounded-sm shadow-sm text-xs lg:text-sm text-primary bg-primary-light text-center mt-6" v-else>
                                {{ __('home::orders.pay_later_terms', { days: delayedPaymentDays }) }}
                            </div>

                            <Button type="button" @click="$emit('next')" class="w-full mt-3 py-4" :disabled="order.photos.length === 0" :class="{ 'cursor-not-allowed opacity-20': order.photos.length === 0 }">
                                {{ __('home::orders.order_now_for') }} {{ formatPrice(subtotalPrice + deliveryPrice, order.currency) }}
                                <ArrowNarrowRightIcon class="h-4 w-4 ml-1" />
                            </Button>

                            <div class="mt-4 text-center">
                                <img src="/media/payment-cards.png" class="inline-block h-8" v-if="$page.props.__site.payment_methods.includes('card')" />
                                <img src="/media/payment-mobilepay.png" class="inline-block h-8" v-if="$page.props.__site.payment_methods.includes('mobilepay')" />
                                <img src="/media/payment-vipps.png" class="inline-block h-8 px-2" v-if="$page.props.__site.payment_methods.includes('vipps')" />
                            </div>

                        </div>
                    </div>

                </div>

            </div>

        </div>

        <!--
        <section v-if="$page.props.__locale === 'da'">
            <div class="w-full max-w-screen-xl mx-auto px-6">
                <TrustBox />
            </div>
        </section>
        -->

        <USPSection class="border-t border-b border-gray-200" />

        <SliderSection class="border-b border-gray-200" />

        <ProductGuideSection />

        <Faq class="mb-16 border-t border-gray-200 pt-16" />

        <StockPhotoSelector
            :open="stockPhotoSelectorOpen"
            :order="order"
            :product="selectedShape"
            @close="stockPhotoSelectorOpen = false"
            @append-photos="appendPhotos($event)"
        />

        <SocialPhotoSelector
            :open="socialPhotoSelectorOpen"
            :order="order"
            :product="selectedShape"
            @close="socialPhotoSelectorOpen = false"
            @append-photos="appendPhotos($event)"
        />

        <ModalPhotoEditor
            v-if="editing"
            :open="editing ? true : false"
            :order="order"
            :photo="editing"
            :product="selectedShape"
            @update:photo="updatePhoto($event); editing = null"
            @delete="deletePhoto($event)"
            @close="editing = null"
        />

        <DeliveryInfo
            :open="deliveryInfoOpen"
            @close="deliveryInfoOpen = false"
        />

    </div>
</template>

<script>
    import axios from 'axios'
    import collect from 'collect.js'

    import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

    import {
        XIcon,
        ExclamationIcon,
    } from '@heroicons/vue/solid'

    import {
        ChevronRightIcon,
        ArrowNarrowRightIcon,
        PlusIcon,
    } from '@heroicons/vue/outline'

    export default {
        components: {
            Menu,
            MenuButton,
            MenuItem,
            MenuItems,
            PlusIcon,
            XIcon,
            ChevronRightIcon,
            ArrowNarrowRightIcon,
            ExclamationIcon,
        },
        props: {
            photos: Object,
            order: Object,
            products: Object,
            subtotalPrice: Number,
            deliveryPrice: Number,
            nextDelivery: String,
            delayedPaymentDays: Number|String,
        },
        data() {
            return {
                uploading: false,
                uploadPercentage: 0,
                stockPhotoSelectorOpen: false,
                socialPhotoSelectorOpen: false,
                deliveryInfoOpen: false,
                editing: null,
                shapes: collect(this.products)
                    .where('category', 'single')
                    .all(),
                selectedShape: { },
            }
        },
        mounted() {
            var photos = collect(this.photos);
            var shapes = collect(this.shapes);

            var lastPhoto = photos.last();

            if (lastPhoto) {
                this.selectedShape = shapes.firstWhere('id', lastPhoto.product_id);
            }
            else if (this.order.meta && this.order.meta['product']) {
                this.selectedShape = shapes.firstWhere('id', this.order.meta['product']) || shapes.first();
            }
            else {
                this.selectedShape = shapes.first();
            }
        },
        methods: {
            handleFileUploads() {

                var files = this.$refs.files.files;

                if (files.length == 0) {
                    return;
                }

                this.uploading = true;
                this.uploadPercentage = 0;

                var request = new FormData();
                request.append('product_id', this.selectedShape.id);

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    request.append('files[' + i + ']', file);
                }

                axios
                    .post(this.$route('home::orders.photos.upload', { uuid: this.order.uuid }), request, {
                        header: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: function(progressEvent) {
                            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        }.bind(this),
                    })
                    .then((res) => {
                        this.uploading = false;
                        this.$refs.files.value = null;
                        this.appendPhotos(res.data);
                    });
            },
            appendPhotos(newPhotos) {
                var photos = this.photos;
                newPhotos.forEach(newPhoto => photos.push(newPhoto));
                this.$emit('update:photos', photos);

                this.$gtm.trackEvent({
                    event: 'UploadPhoto',
                    category: 'PhotoCreation',
                });
            },
            updatePhoto(photo) {
                this.editing = photo;
                var photos = this.photos;
                var index = this.photos.findIndex(x => x.id === photo.id);
                photos.splice(index, 1, photo);
                this.$emit('update:photos', photos);
            },
            deletePhoto() {
                axios
                    .delete(this.$route('home::orders.photos.destroy', { uuid: this.order.uuid, photo: this.editing.id }))
                    .then((res) => {
                        var photos = this.photos;
                        var index = this.photos.findIndex(x => x.id === this.editing.id);
                        photos.splice(index, 1);
                        this.$emit('update:photos', photos);
                        this.editing = null;
                    });
            },
            updateShape(shape) {

                if (shape.id == this.selectedShape.id) {
                    return;
                }

                var photosWithCropping = collect(this.photos)
                    .sum((photo) => {
                        return photo.modifications && 'cropper' in photo.modifications ? 1 : 0;
                    });

                if (photosWithCropping > 0) {
                    var c = confirm(this.__('home::orders.change_of_shape_will_remove_cropping'));
                }
                else {
                    var c = true;
                }

                if (c) {

                    this.selectedShape = shape;

                    var request = {
                        product_id: shape.id,
                    };

                    axios
                        .post(this.$route('home::orders.photos.mass-update-shape', { uuid: this.order.uuid }), request)
                        .then((res) => {
                            this.$emit('update:photos', res.data);
                        })

                }
            },
        },
    }
</script>
